import { ReactNode } from "react";

import { ProductComparisonBarContextProvider } from "./context/productComparisonBar.context";
import { useProducts } from "./hooks/useProducts.hook";

type Props = {
    children: ReactNode;
};

export const Base = ({ children }: Props) => {
    const { products, remove, clear } = useProducts();

    if (!products?.length) {
        return null;
    }

    return (
        <ProductComparisonBarContextProvider
            products={products}
            remove={remove}
            clear={clear}
        >
            {children}
        </ProductComparisonBarContextProvider>
    );
};
